export default {
      id: "fill-check-usage",
      viewBox: "0 0 50 50",
      url: "/dist/svg/" + "sprite.svg#fill-check-usage",
      toString: function () {
        return this.url;
      }
    }